import React, { useRef } from "react";
import "./style.scss";

export const GeneralSearchInput = (props) => {
    const inputRef = useRef();

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            handleChange([e.target.value]);
        }
    };

    const handleChange = () => {
        const inputValue = inputRef.current.value
        const qs = Utils.setQueryStringValue("mainSearch", inputValue);
        const url = `/he/search-global${qs}`;
        location.assign(url);
    };

    return (
        <>
            <input type="text" placeholder={props?.props?.labels['search-placholder']} className="general-search-input" ref={inputRef} onKeyDown={handleKeyDown} />
        </>
    );
};
